module.exports = __webpack_public_path__ + "files/daaa6212430f06392b04c27f10a806a1.png";